import axios from "axios";
import axiosInstance from "../../../../setup/axios/SetupAxios";
const API_URL = process.env.REACT_APP_BASE_URL

export const COUNTRY_LIST_URL = `${API_URL}/api/v1/countries`;
export const TIMEZONEID_LIST_URL = `${API_URL}/api/v1/timezone`;
export const LANGUAGE_DATA_URL = `${API_URL}/api/v1/language-data`;
export const PRESIGNED_DATA_URL = `${API_URL}/api/v1/pre-signed-url`;
export const IP_ADDRESS_URL = `https://ip-geolocation.whoisxmlapi.com/api/v1?apiKey=at_dfeR8ph4b6hk19xcB8X1IyDamlCPr`;
export const COUNTRY_BY_IP_URL = `https://ip-geolocation.whoisxmlapi.com/api/v1?apiKey=at_dfeR8ph4b6hk19xcB8X1IyDamlCPr`;
export const ADD_PARENT_GEN_PWD_URL = `${API_URL}/api/v1/parent/generate-password`;
export const LANGUAGE_URL = `${API_URL}/api/v1/parent/languages`;
export const DELETE_ACTIVITY_URL = `${API_URL}/api/v1/parent/delete-activity`;

export function getCountryList(translation_id) {
    return axios({
        url: COUNTRY_LIST_URL,
        method: "GET",
        params: { translation_id }
    })
}

export function getTimezoneList() {
    return axios({
        url: TIMEZONEID_LIST_URL,
        method: "GET"
    })
}

export function getLangTranslationData(translationId) {
    const d = new Date();
    const timezone = d.getTimezoneOffset();
    return axios({
        url: LANGUAGE_DATA_URL,
        method: "GET",
        headers: {
            language: navigator?.language ? navigator?.language?.slice(0, 2) : 'en',
            timezone_offset: -1 * timezone,
            version_code: 10020
        },
        params: {
            translation_id: translationId
        }
    })
}

export function getPreSignedUrl(payload) {
    const d = new Date();
    const timezone = d.getTimezoneOffset();
    return axios({
        url: PRESIGNED_DATA_URL,
        method: "POST",
        headers: {
            language: navigator?.language ? navigator?.language?.slice(0, 2) : 'en',
            timezone_offset: -1 * timezone,
            version_code: 20000
        },
        data: payload
    })
}

export function uploadFileToS3(url, payload, headers) {
    return axios({
        url,
        method: 'PUT',
        headers,
        data: payload
    })
}

export function getMyIPAddress() {
    return axios({
        url: IP_ADDRESS_URL,
        method: 'GET'
    })
}

export function getCountryByIp(myIpAddress) {
    return axios({
        url: COUNTRY_BY_IP_URL,
        method: 'GET',
        params: { ipAddress: myIpAddress }
    })
}

export function additionalParentGeneratePwd(payload) {
    return axios({
        url: ADD_PARENT_GEN_PWD_URL,
        method: 'POST',
        data: payload
    })
}

export function getLanguages(token, lang) {
    const d = new Date();
    const timezone = d.getTimezoneOffset();
    return axios({
        url: LANGUAGE_URL,
        method: "GET",
        headers: {
            Authorization: token,
            language: navigator?.language ? navigator?.language?.slice(0, 2) : lang,
            timezone_offset: -1 * timezone,
            version_code: 10020
        }
    })
}

export function deleteActivityService(payload) {
    return axiosInstance({
        url: DELETE_ACTIVITY_URL,
        method: "POST",
        data: payload
    })
}
